import { Flex, Heading } from '@aws-amplify/ui-react'
import { fetchUserAttributes } from 'aws-amplify/auth'
import { useCallback, useEffect, useState } from 'react'

import ReturnLink from '../../components/ReturnLink'
import ProfileDetailsForm from './ProfileDetailsForm'
import ValidationForm from './ValidationForm'
import UpdatePasswordForm from './UpdatePasswordForm'

const ProfileSettings = () => {
  const [emailChanged, setEmailChanged] = useState(false)
  const [resetPassword, setResetPassword] = useState(false)
  const [currentName, setCurrentName] = useState()
  const [currentEmail, setCurrentEmail] = useState()

  const getNonCachedUser = useCallback(
    async () => {
      const attributes = await fetchUserAttributes()
      setCurrentEmail(attributes.email)
      setCurrentName(attributes.name)
      return attributes
    },
    []
  )

  useEffect(
    () => {
      getNonCachedUser()
    },
    [getNonCachedUser]
  )

  const showResetPassword = useCallback(
    (value) => {
      setResetPassword(value)
    },
    []
  )

  const validateEmail = async (value) => {
    await getNonCachedUser()
    setEmailChanged(value)
  }

  const loaded = currentEmail !== undefined

  if (resetPassword) return (
    <Flex direction='column' gap='2rem'>
     <ReturnLink onClick={() => showResetPassword(false)} />
      <Heading
        level={1}
        style={{ fontSize: '1.5rem', fontWeight: 400 }}
      >
        Profile settings
      </Heading>

      <UpdatePasswordForm
        showResetPassword={showResetPassword}
      />
    </Flex>
  )

  return (
    <Flex direction='column' gap='2rem'>
      <ReturnLink url='/' />
      <Heading
        level={1}
        style={{ fontSize: '1.5rem', fontWeight: 400 }}
      >
        Profile settings
      </Heading>

      {loaded && (emailChanged ? (
        <ValidationForm validateEmail={validateEmail} />
      ) : (
        <ProfileDetailsForm
          currentEmail={currentEmail}
          currentName={currentName}
          validateEmail={validateEmail}
          showResetPassword={showResetPassword}
        />
      ))}
    </Flex>
  )
}

export default ProfileSettings
